<template>
	<Icon>
		<template #component>
			<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="currentColor" viewBox="0 0 24 24">
				<path fill="currentColor" d="M14.025 23.2q-.425 0-.725-.287T13 22.2t.288-.712T14 21.2q2.925 0 4.963-2.037T21 14.2q0-.425.288-.712T22 13.2t.713.288t.287.712q0 1.85-.712 3.488t-1.925 2.862t-2.85 1.938t-3.488.712m0-4q-.425 0-.725-.287T13 18.2t.288-.712T14 17.2q1.25 0 2.125-.875T17 14.2q0-.425.288-.712T18 13.2t.713.288t.287.712q-.025 2.075-1.463 3.525T14.026 19.2M5.55 22.575q-.375 0-.75-.15T4.125 22l-3.55-3.55q-.275-.3-.425-.675t-.15-.75q0-.4.15-.763t.425-.637L3.75 12.45q.575-.575 1.425-.587t1.425.562l1.25 1.25l.7-.7l-1.25-1.25q-.575-.575-.575-1.4t.575-1.4L8.725 7.5q.575-.575 1.413-.575t1.412.575l1.25 1.25l.7-.7l-1.25-1.25q-.575-.575-.575-1.412t.575-1.413L15.425.8q.3-.3.675-.45t.75-.15t.738.15t.662.45l3.55 3.55q.3.275.438.638t.137.762q0 .375-.137.75t-.438.675l-3.175 3.175q-.575.575-1.412.575T15.8 10.35L14.55 9.1l-.7.7l1.25 1.25q.575.575.563 1.413t-.588 1.412l-1.4 1.4q-.575.575-1.412.575t-1.413-.575l-1.25-1.25l-.7.7l1.25 1.25q.575.575.563 1.425t-.588 1.425L6.95 22q-.275.275-.638.425t-.762.15m0-1.975l3.15-3.15L5.15 13.9L2 17.05zm6.81-6.81l1.4-1.4l-3.55-3.55l-1.4 1.4zm4.95-4.95l3.25-3.25l-3.5-3.55l-3.25 3.25zM19.35 1.05zm-8.15 4.6"/>
			</svg>
		</template>
	</Icon>
</template>

<script>
import Icon from '@ant-design/icons-vue';

// manually modified from
// https://icones.js.org/collection/material-symbols?s=satellite&icon=material-symbols:satellite-alt-outline-rounded
export default {
	components: { Icon },
};
</script>
